import { memo } from 'react';

// NOTE: This function should not be used inside of UIComponents because it causes incorrect code example output inside of Storybook. See https://hubspot.slack.com/archives/C03B30XDPS4/p1689797941421749 for more info.

/**
 * Workaround for a React bug where attaching `displayName` to a `memo`'d component doesn't result
 * in that `displayName` being recognized by React (e.g. in Dev Tools).
 *
 * @param {string} displayName The `displayName` to attach to the given `Component`
 * @param {Function} Component A function component to memoize
 */
export default function memoWithDisplayName(displayName, Component) {
  Component.displayName = displayName;
  return /*#__PURE__*/memo(Component);
}